<template>
  <div>
    <NuxtLink :to="`/clients/${client._id}`" class="">Back to {{client.name}}</NuxtLink>

    <h2
      class="text-6xl font-extrabold leading-none tracking-tight text-gray-900 dark:text-white"
    >
      {{ search.name }}
    </h2>
    <ul>
      <li>Last Updated: {{ search.updated }}</li>
      <li>Status: {{ search.status }}</li>
      <li>Description: {{ search.description }}</li>
    </ul>
    
    <UpdateSearch :search="search" />
    
    <ExecuteSearch :search="search" />

    <Section>
      <div class="text-2xl font-bold mb-5">
        Search Results
      </div>
      <SearchResultsTable :search="search" />
    </Section>

  </div>
</template>

<script setup>
import _ from "lodash";
import UpdateSearch from "~/features/searches/UpdateSearch.vue";
import { computed } from "vue";
import { useSearchStore, useClientStore } from "~/store";
import SearchResultsTable from "~/features/searches/SearchResultsTable.vue";
import ExecuteSearch from "~/features/searches/ExecuteSearch.vue";
const searchStore = useSearchStore();
const clientStore = useClientStore();

const route = useRoute();
const { searchId } = route.params;
const search = computed(() => searchStore.getSearch(searchId));
const client = computed(() => clientStore.getClient(search.value.clientId));

</script>

<style scoped>
/* CSS specific to this page */
</style>
